/* =========================================================================
   MWC Hero Buy (sections/mwc-hero-buy.liquid)
   Gallery with a video slide, plan picker, countdown, arrival dates,
   one-line trust rows on phones, and the supplement facts popup.
   Add to cart, "Join" scrolling and the sticky bar live in mwc-blake.js.
   Each part is wrapped so one failure can't stop the others.
   ========================================================================= */
(function () {
  if (window.__mwcHeroBuy) return;
  window.__mwcHeroBuy = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function safe(fn, root) {
    try { fn(root); } catch (e) { if (window.console) console.warn('[mwc-hero-buy]', e); }
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var gal = root.querySelector('[data-hb-gal]');
    var track = gal && gal.querySelector('[data-hb-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-hb-slide]');
    var thumbsWrap = gal.querySelector('[data-hb-thumbs]');
    var thumbs = thumbsWrap ? thumbsWrap.querySelectorAll('[data-hb-thumb]') : [];
    var prev = gal.querySelector('[data-hb-prev]');
    var next = gal.querySelector('[data-hb-next]');
    var count = slides.length;
    var current = -1;
    var ticking = false;

    function idx() {
      var w = track.clientWidth || 1;
      return Math.max(0, Math.min(count - 1, Math.round(track.scrollLeft / w)));
    }
    function go(i) {
      i = Math.max(0, Math.min(count - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function pauseVideos() {
      Array.prototype.forEach.call(track.querySelectorAll('video'), function (v) { if (!v.paused) v.pause(); });
    }
    function sync() {
      ticking = false;
      var i = idx();
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === count - 1;
      if (i === current) return;
      current = i;
      pauseVideos();
      Array.prototype.forEach.call(thumbs, function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      var t = thumbs[i];
      if (t && thumbsWrap) {
        var left = t.offsetLeft - thumbsWrap.offsetLeft - (thumbsWrap.clientWidth - t.offsetWidth) / 2;
        thumbsWrap.scrollTo({ left: Math.max(0, left), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    track.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(sync); }
    }, { passive: true });
    Array.prototype.forEach.call(thumbs, function (b, k) {
      b.addEventListener('click', function () { go(k); });
    });
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1); }
    });
    window.addEventListener('resize', function () {
      if (current >= 0) track.scrollTo({ left: current * track.clientWidth, behavior: 'auto' });
    });

    /* Video slide: the <video> lives in a <template>, so nothing downloads until it's tapped */
    Array.prototype.forEach.call(track.querySelectorAll('[data-hb-video]'), function (slide) {
      var btn = slide.querySelector('[data-hb-play]');
      var tpl = slide.querySelector('[data-hb-video-tpl]');
      if (!btn || !tpl || !tpl.content) return;
      btn.addEventListener('click', function () {
        var video = tpl.content.querySelector('video');
        if (!video) return;
        video = video.cloneNode(true);
        video.setAttribute('preload', 'auto');
        slide.replaceChild(video, btn);
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        video.focus();
      });
    });

    sync();
  }

  /* ---------- Plan picker ---------- */
  function initPlans(root) {
    var group = root.querySelector('.mwc-hb__plans');
    var form = root.querySelector('[data-hb-form]');
    if (!group || !form) return;
    var submit = form.querySelector('[data-hb-submit]');
    var stock = root.querySelector('[data-hb-stock]');

    group.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      Array.prototype.forEach.call(group.querySelectorAll('.mwc-hb-plan'), function (card) {
        card.classList.toggle('is-selected', card.contains(input));
      });

      form.querySelector('[name="id"]').value = input.getAttribute('data-variant-id');
      var sp = form.querySelector('[name="selling_plan"]');
      sp.value = input.getAttribute('data-selling-plan-id') || '';
      sp.disabled = !sp.value;
      form.querySelector('[name="quantity"]').value = input.getAttribute('data-quantity') || 1;

      if (submit) {
        var available = input.getAttribute('data-available') === 'true';
        submit.disabled = !available;
        submit.textContent = available ? submit.getAttribute('data-label') : submit.getAttribute('data-soldout');
      }

      if (stock) {
        var ready = input.getAttribute('data-in-stock') === 'true';
        var text = stock.querySelector('[data-hb-stock-text]');
        if (text) text.textContent = stock.getAttribute(ready ? 'data-ready-text' : 'data-replenish-text');
        stock.classList.toggle('mwc-hb-trust__item--ready', ready);
        stock.classList.toggle('mwc-hb-trust__item--replenish', !ready);
        if (root.__hbFit) root.__hbFit();
      }
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdown(root) {
    var el = root.querySelector('[data-hb-countdown]');
    if (!el) return;
    var end = Date.parse(el.getAttribute('data-end'));
    if (isNaN(end)) return;
    var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    if (root.__hbTimer) clearInterval(root.__hbTimer);
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { clearInterval(root.__hbTimer); el.hidden = true; return; }
      d.textContent = pad(Math.floor(left / 86400));
      h.textContent = pad(Math.floor((left % 86400) / 3600));
      m.textContent = pad(Math.floor((left % 3600) / 60));
      s.textContent = pad(left % 60);
    }
    root.__hbTimer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Estimated arrival: today in Central time + start/end days ---------- */
  function initEta(root) {
    var el = root.querySelector('[data-hb-eta]');
    var out = el && el.querySelector('[data-hb-eta-range]');
    if (!out || !window.Intl) return;
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
    var y, mo, d;
    parts.forEach(function (p) {
      if (p.type === 'year') y = +p.value;
      if (p.type === 'month') mo = +p.value;
      if (p.type === 'day') d = +p.value;
    });
    var fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' });
    function plus(n) { return fmt.format(new Date(Date.UTC(y, mo - 1, d + n))); }
    out.textContent = plus(parseInt(el.getAttribute('data-start'), 10) || 0) + ' - ' + plus(parseInt(el.getAttribute('data-end'), 10) || 0);
  }

  /* ---------- Phones: keep each trust row on one line (steps down to 9px) ---------- */
  function initFit(root) {
    var rows = root.querySelectorAll('[data-hb-fit]');
    if (!rows.length || !window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 767px)');
    function fit() {
      Array.prototype.forEach.call(rows, function (row) {
        row.style.fontSize = '';
        if (!mq.matches) return;
        var size = parseFloat(window.getComputedStyle(row).fontSize) || 12;
        var guard = 0;
        while (row.scrollWidth > row.clientWidth + 1 && size > 9 && guard < 12) {
          size -= 0.5;
          row.style.fontSize = size + 'px';
          guard++;
        }
      });
    }
    root.__hbFit = fit;
    fit();
    window.addEventListener('resize', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  /* ---------- Supplement facts popup ---------- */
  function initFacts(root) {
    var dialog = root.querySelector('[data-hb-facts]');
    var open = root.querySelector('[data-hb-facts-open]');
    if (!dialog || !open || typeof dialog.showModal !== 'function') return;
    open.addEventListener('click', function () { dialog.showModal(); });
    dialog.querySelector('[data-hb-facts-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-hb-root]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.__hbReady) return;
      root.__hbReady = true;
      safe(initGallery, root);
      safe(initPlans, root);
      safe(initCountdown, root);
      safe(initEta, root);
      safe(initFit, root);
      safe(initFacts, root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-hb-root]');
    if (root && root.__hbTimer) clearInterval(root.__hbTimer);
  });
})();
